export default function ResultsSummary({ total, search }) {
  return (
    <p className="text-sm text-muted-foreground">
      Showing <span className="font-medium text-foreground">{total}</span> products
      {search ? (
        <>
          {" "}
          for <span className="font-medium text-foreground">“{search}”</span>
        </>
      ) : null}
    </p>
  );
}